// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pao_mid":"pao_mid-3PiRjGBU","box":"box-2b7T42r_","dot":"dot-1kQc-dtx","current":"current-7JOwQBk8 dot-1kQc-dtx"};